import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function KoreanMesotherapyHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1536">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/61TpSH1TeywtvW8fLWYSdc/Mesotherapy.jpg)'
    }} data-id="element-1537" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1538" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1539">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1540">
          <div className="mb-6" data-id="element-1541">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1542">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1543">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1544">
            Be BOLD
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[60px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1545">
            KOREAN MESOTHERAPY
          </h1>

          <div className="space-y-6" data-id="element-1546">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1547">
              If you're interested in the ancient skin benefits of Korean
              Mesotherapy, Be CLINICAL offers an elevated version called
              MicroPotions. These are our exclusive, cutting-edge interpretation
              of traditional Korean Mesotherapy.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1548">
              Using a state-of-the-art mesotherapy 'gun,' we precisely inject a
              powerful blend of skin-boosting ingredients directly into the skin
              to rejuvenate, brighten and tighten the skin from within for a
              dewy, youthful glow. Enjoy the many benefits of traditional Korean
              Mesotherapy right here in San Ramon, CA, at Be CLINICAL!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1549">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}